export default "__VITE_ASSET__D1XK7Fdb__"